export default "__VITE_ASSET__h64gi0cT__"